/**
 * i18n de pedidos online — área POS: la BANDEJA de pedidos online en comandas (tarjetas, aceptar/rechazar, estados, sonido): pedidos.pos.*
 * Un archivo por área para que cada pantalla escriba en el suyo sin pisarse (ver index.js).
 *
 * Los `pedidos.pos.paper.*` salen IMPRESOS (comanda y ticket de la bolsa): cortos, en mayúsculas
 * donde el papel lo pide, y sin caracteres raros (la comandera imprime en cp858).
 */
const pos = {
  es: {
    "pedidos.pos.title.one": "Pedido online",
    "pedidos.pos.title.many": "Pedidos online",

    "pedidos.pos.section.title": "Pedidos online ({n})",
    "pedidos.pos.section.hint": "Los pedidos que hacen tus clientes desde la web caen acá.",
    "pedidos.pos.section.hintPending": "Respondé antes de que venza: {n} esperando.",
    "pedidos.pos.section.hintLink": "Tu link para pedir: {link}",
    "pedidos.pos.section.emptyOpen": "Todavía no entró ningún pedido. Cuando entre uno, suena y aparece acá.",
    "pedidos.pos.section.emptyClosed": "La tienda online está cerrada: no entran pedidos hasta que la abras.",
    "pedidos.pos.section.emptyOpenMuted": "Todavía no entró ningún pedido. Esta pantalla no suena: mirala de vez en cuando.",
    "pedidos.pos.section.notListening": "Esta pantalla no avisa los pedidos. Si ninguna otra pantalla suena, la tienda no toma pedidos.",
    "pedidos.pos.section.notListeningIdle": "Hace más de 2 horas que nadie toca esta pantalla: tocala para que siga avisando los pedidos. Si ninguna otra suena, la tienda no toma pedidos.",
    "pedidos.pos.section.notListeningNoTouch": "Tocá esta pantalla una vez para que avise los pedidos. Si ninguna otra suena, la tienda no toma pedidos.",
    "pedidos.pos.section.full": "Lleno: no entran pedidos nuevos hasta que respondas ({n}/{max} esperando).",
    "pedidos.pos.section.listenHere": "Que suene acá",

    "pedidos.pos.store.open": "Tomando pedidos",
    "pedidos.pos.store.pausedUntil": "Pausada hasta las {time}",
    "pedidos.pos.store.autoClosed": "Se cerró sola",
    "pedidos.pos.store.closed": "Tienda cerrada",
    "pedidos.pos.store.pause": "Pausar",
    "pedidos.pos.store.pause30": "Pausar 30 min",
    "pedidos.pos.store.pause60": "Pausar 1 hora",
    "pedidos.pos.store.pauseNext": "Hasta que vuelva a abrir",
    "pedidos.pos.store.close": "Cerrar la tienda",
    "pedidos.pos.store.resume": "Reanudar",
    "pedidos.pos.store.openNow": "Abrir la tienda",

    "pedidos.pos.sound.on": "Suena acá",
    "pedidos.pos.sound.off": "No suena acá",
    "pedidos.pos.sound.hint": "Si suena el aviso de pedidos en esta pantalla. En los celulares de los mozos viene apagado.",

    "pedidos.pos.card.kindEnvio": "Envío",
    "pedidos.pos.card.kindRetiro": "Retira",
    "pedidos.pos.card.noName": "Sin nombre",
    "pedidos.pos.card.agoNow": "recién",
    "pedidos.pos.card.agoMin": "hace {n} min",
    "pedidos.pos.card.agoHour": "hace {h} h {m} min",
    "pedidos.pos.card.riskNew": "Cliente nuevo",
    "pedidos.pos.card.riskPrior": "Ya pidió {n}",
    "pedidos.pos.card.riskFailed": "{n} sin concretar",
    "pedidos.pos.card.toBuild": "Se aceptó pero no se llegó a armar ni imprimir.",
    "pedidos.pos.card.itemsAria": "{n} productos",
    "pedidos.pos.card.itemsAriaOne": "{n} producto",
    "pedidos.pos.card.more": "y {n} más",
    "pedidos.pos.card.payTransfer": "Transferencia: verificá antes de entregar",
    "pedidos.pos.card.payTransferWait": "Transferencia: se cocina cuando llegue",
    "pedidos.pos.card.acceptNote": "Al aceptar sale la comanda a la cocina y el cliente ve «Confirmado · llega {time}».",
    "pedidos.pos.card.acceptNotePickup": "Al aceptar sale la comanda a la cocina y el cliente ve «Confirmado · retiralo {time}».",
    "pedidos.pos.card.acceptNoteWait": "Al aceptar NO sale a la cocina: el cliente ve tu alias para transferir. La comanda sale cuando toques «Llegó la transferencia».",
    "pedidos.pos.card.toBuildPaid": "Llegó la transferencia, pero la comanda todavía no salió a la cocina.",
    "pedidos.pos.card.payCashExact": "Efectivo, paga justo",
    "pedidos.pos.card.payCashWith": "Efectivo, paga con {amount} (vuelto {change})",
    "pedidos.pos.card.payCashShort": "Efectivo, dice que paga con {amount}: no alcanza",
    "pedidos.pos.card.payCash": "Efectivo",
    "pedidos.pos.card.noAddress": "Sin dirección",
    "pedidos.pos.card.pinAt": "pin a {km}",
    "pedidos.pos.card.fee": "envío {amount}",
    "pedidos.pos.card.cash": "Descuento efectivo {pct}%: −{amount} (ya está en el total)",
    "pedidos.pos.card.feeFree": "envío gratis",
    "pedidos.pos.card.feeCoordinate": "envío a coordinar",
    "pedidos.pos.card.testBadge": "PRUEBA",
    "pedidos.pos.card.testHint": "Pedido de prueba que te mandaste: aceptalo para ver la comanda y la bolsa. No se cobra ni queda en la caja.",
    "pedidos.pos.card.testHintBuilt": "Prueba aceptada que no se terminó de imprimir. Imprimila o descartala: no queda en la caja.",
    "pedidos.pos.card.testDiscard": "Descartar",
    "pedidos.pos.card.testPrint": "Imprimir la prueba",
    "pedidos.pos.card.testNoPrinterQ": "No hay ninguna comandera conectada: la prueba no puede imprimir. Conectala y aceptala de nuevo, o descartala.",
    "pedidos.pos.card.map": "Mapa",
    "pedidos.pos.card.pinFar": "El pin del mapa queda a {km} de la dirección escrita: confirmala con el cliente.",
    "pedidos.pos.card.pinMismatch": "La dirección y el pin del mapa no coinciden: confirmala con el cliente.",
    "pedidos.pos.card.soldOut": "Sin stock: {list}",
    "pedidos.pos.card.etaAria": "Demora en minutos",
    "pedidos.pos.card.accept": "Aceptar · {min} min",
    "pedidos.pos.card.accepting": "Aceptando…",
    "pedidos.pos.card.reject": "Rechazar",
    "pedidos.pos.card.acceptNoPrint": "Aceptar sin imprimir",
    "pedidos.pos.card.expiresIn": "vence en {time}",
    "pedidos.pos.card.expiresNow": "venciendo…",
    "pedidos.pos.card.build": "Armar e imprimir",
    "pedidos.pos.card.building": "Armando…",
    "pedidos.pos.card.leaseOther": "Lo está armando otro equipo. Esperá unos segundos.",
    "pedidos.pos.card.call": "Llamar",
    "pedidos.pos.card.whatsapp": "WhatsApp",
    "pedidos.pos.card.view": "Ver",
    "pedidos.pos.card.cannotBuild": "Esta pantalla no puede armar este pedido. No lo aceptes: rechazalo o atendelo por WhatsApp (si se repite, recargá la página).",
    "pedidos.pos.card.noPrinterQ": "No hay ninguna comandera disponible: si lo aceptás, no sale el papel para la cocina. ¿Lo aceptás sin imprimir?",
    "pedidos.pos.card.noPrinterBuildQ": "No hay ninguna comandera disponible: no va a salir el papel para la cocina. ¿Lo armás sin imprimir?",
    "pedidos.pos.card.buildNoPrint": "Armar sin imprimir",
    "pedidos.pos.card.cancel": "Cancelar (le avisamos al cliente)",
    "pedidos.pos.card.cancelConfirm": "¿Seguro? Tocá de nuevo para cancelar",
    "pedidos.pos.card.ref": "Ref. del cliente: {ref}",
    "pedidos.pos.card.payClaim": "El cliente escribió algo sobre el pago: verificá cómo paga antes de entregar.",

    "pedidos.pos.reject.why": "¿Por qué lo rechazás? (el cliente lo ve)",
    "pedidos.pos.reject.sin_stock": "Sin stock",
    "pedidos.pos.reject.cerrado": "Estamos cerrando",
    "pedidos.pos.reject.fuera_de_zona": "Fuera de zona",
    "pedidos.pos.reject.demora": "Mucha demora",
    "pedidos.pos.reject.otro": "Otro motivo",
    "pedidos.pos.reject.soldOutQ": "¿Qué se agotó? Lo dejamos sin poder pedir hasta que cierres hoy.",
    "pedidos.pos.reject.confirmSoldOut": "Rechazar y marcar {n} agotado(s)",
    "pedidos.pos.reject.confirmPlain": "Rechazar sin marcar nada",
    "pedidos.pos.reject.back": "Volver",

    "pedidos.pos.live.accepted": "Confirmado",
    "pedidos.pos.live.ready": "Listo",
    "pedidos.pos.live.readyPickup": "Listo para retirar",
    "pedidos.pos.live.out": "En camino",
    "pedidos.pos.live.items": "{n} productos",
    "pedidos.pos.live.itemsOne": "{n} producto",
    "pedidos.pos.live.eta": "le dijimos {time}",
    "pedidos.pos.live.paid": "Transferencia recibida ✓",
    "pedidos.pos.live.verify": "Esperando la transferencia",
    "pedidos.pos.live.unsent": "Sin mandar a cocina",
    "pedidos.pos.live.amendQ": "El pedido cambió: el cliente ve {from} y ahora es {to}.",
    "pedidos.pos.live.amend": "Avisarle el total nuevo",
    "pedidos.pos.live.amendOk": "El cliente aceptó {to}",
    "pedidos.pos.live.markReady": "Está listo",
    "pedidos.pos.live.markOut": "Salió",
    "pedidos.pos.live.markPaid": "Llegó la transferencia",
    "pedidos.pos.live.open": "Abrir",
    "pedidos.pos.live.sendNow": "Mandar a cocina",
    "pedidos.pos.live.cancel": "Cancelar",
    "pedidos.pos.live.cancelConfirm": "¿Cancelar el pedido?",
    "pedidos.pos.live.acceptedAgo": "Aceptado {ago}",
    "pedidos.pos.live.more": "Ver acciones",
    "pedidos.pos.live.less": "Ocultar acciones",
    "pedidos.pos.live.charge": "Cobrar {total}",
    "pedidos.pos.live.seesReady": "Cliente: «Listo»",
    "pedidos.pos.live.seesReadyPickup": "Cliente: «Listo para retirar»",
    "pedidos.pos.live.seesOut": "Cliente: «En camino»",
    "pedidos.pos.live.seesPaid": "Cliente: «Transferencia recibida»",
    "pedidos.pos.live.seesDone": "Cliente: «Entregado»",
    "pedidos.pos.live.seesPickedUp": "Cliente: «Retirado»",
    "pedidos.pos.live.chargeDelivered": "Entregado · cobrar",
    "pedidos.pos.live.chargePickedUp": "Lo retiró · cobrar",
    "pedidos.pos.live.bagVerify": "La bolsa dice VERIFICAR: ya llegó",
    "pedidos.pos.live.reprintBag": "Reimprimir la bolsa",
    "pedidos.pos.live.webCodeTitle": "Pedido web {code}: el código que ve el cliente",
    "pedidos.pos.await.chip": "Sin cocinar · espera la transferencia hasta {time}",
    "pedidos.pos.await.chipNoTime": "Sin cocinar · esperando la transferencia · {n} min",
    "pedidos.pos.await.chipLate": "Sin cocinar · no llegó la transferencia · {n} min",
    "pedidos.pos.await.arrivedSees": "Sale la comanda · cliente: «Transferencia recibida»",
    "pedidos.pos.await.wa": "Hola {name}, ¿pudiste transferir {amount} al alias {alias}? Preparamos tu pedido {code} apenas llegue.",
    "pedidos.pos.await.cancelLate": "No transfirió · cancelar",
    "pedidos.pos.await.cancelConfirm": "¿Cancelar? El cliente ve «No llegó la transferencia»",
    "pedidos.pos.await.cancelConfirmEarly": "¿Cancelar? El cliente ve «El local canceló el pedido»",
    "pedidos.pos.await.late": "Pasaron {n} min y no llegó la transferencia: escribile, o cancelalo (el cliente ve «No llegó la transferencia»).",
    "pedidos.pos.amend.added": "Se agregó: {list}",
    "pedidos.pos.amend.removed": "Se sacó: {list}",
    "pedidos.pos.amend.discount": "Descuento",
    "pedidos.pos.amend.charge": "Recargo",
    "pedidos.pos.amend.fee": "Envío {amount}",
    "pedidos.pos.miss.open": "Falta algo",
    "pedidos.pos.miss.title": "Falta algo del pedido",
    "pedidos.pos.miss.q": "¿Qué no tenés?",
    "pedidos.pos.miss.howMany": "Faltan",
    "pedidos.pos.miss.ofN": "de {n}",
    "pedidos.pos.miss.soldOut": "Marcarlo agotado hasta que cierre (así nadie más lo pide)",
    "pedidos.pos.miss.without": "Sacarlo y seguir",
    "pedidos.pos.miss.swap": "Cambiar por…",
    "pedidos.pos.miss.ask": "Preguntarle al cliente",
    "pedidos.pos.miss.askHint": "El cliente lo ve en su pedido y le llega un WhatsApp para elegir: seguir sin eso, cambiarlo o cancelar.",
    "pedidos.pos.miss.swapQ": "¿Por qué lo cambiás? (en lugar de {list})",
    "pedidos.pos.miss.search": "Buscá en la carta…",
    "pedidos.pos.miss.noResults": "No hay nada con ese nombre.",
    "pedidos.pos.miss.seeIt": "Ver cómo queda",
    "pedidos.pos.miss.looksLike": "Así queda el pedido:",
    "pedidos.pos.miss.newTotal": "Total nuevo {total} (antes {before})",
    "pedidos.pos.miss.customerOk": "El cliente aceptó pagar {total}",
    "pedidos.pos.miss.confirm": "Confirmar el cambio",
    "pedidos.pos.miss.saving": "Guardando…",
    "pedidos.pos.miss.afterNote": "Después lo aceptás como siempre: a la cocina sale el pedido nuevo y el cliente ve el total nuevo.",
    "pedidos.pos.miss.priceChanged": "El total cambió recién (precios de la carta): revisalo y confirmá de nuevo.",
    "pedidos.pos.miss.needsOk": "Sale más caro que lo que pidió: confirmá que el cliente aceptó.",
    "pedidos.pos.miss.resend": "Reenviar WhatsApp",
    "pedidos.pos.miss.resolve": "Resolverlo sin el cliente",
    "pedidos.pos.miss.waiting": "Le preguntaste a {name} qué hacer sin {list}",
    "pedidos.pos.miss.noAnswer": "{name} no contestó qué hacer sin {list}",
    "pedidos.pos.miss.answerIn": "contesta en {time}",
    "pedidos.pos.miss.answerSwap": "{name} eligió cambiar {removed} por {added}.",
    "pedidos.pos.miss.answerWithout": "{name} eligió seguir sin {removed}.",
    "pedidos.pos.miss.changed": "Pedido cambiado: {list}.",
    "pedidos.pos.miss.without1": "sin {list}",
    "pedidos.pos.miss.with1": "con {list}",
    "pedidos.pos.miss.before": "(antes {total})",
    "pedidos.pos.miss.waHi": "¡Hola!",
    "pedidos.pos.miss.waHiName": "¡Hola {name}!",
    "pedidos.pos.miss.waMsg": "{hi} Te escribimos de {local} por tu pedido #{code}. No nos queda {items} 😕 ¿Lo querés cambiar por otra cosa o seguimos sin eso? Elegilo acá: {link}",
    "pedidos.pos.miss.err.noCart": "Este pedido es de antes de esta función: aceptalo y cambialo desde el pedido.",
    "pedidos.pos.miss.err.empty": "No queda nada en el pedido: si no tenés nada de lo que pidió, rechazalo.",
    "pedidos.pos.miss.err.stale": "El pedido cambió recién (¿contestó el cliente?): revisalo.",
    "pedidos.pos.miss.err.gone": "Este pedido ya no está esperando respuesta.",
    "pedidos.pos.miss.err.catalog": "No se pudo leer la carta: probá de nuevo.",
    "pedidos.pos.miss.err.tooMany": "Este pedido ya se cambió varias veces: aceptalo y cambialo desde el pedido, o rechazalo.",
    "pedidos.pos.miss.err.offline": "Sin conexión: probá de nuevo.",
    "pedidos.pos.miss.err.generic": "No se pudo cambiar el pedido ({code}).",
    "pedidos.pos.miss.err.soldOut": "{name} está agotado.",
    "pedidos.pos.miss.err.paused": "{name} no se vende online ahora.",
    "pedidos.pos.miss.err.productGone": "{name} ya no está en la carta online.",
    "pedidos.pos.miss.err.options": "{name} tiene opciones para elegir: preguntale al cliente, que lo elija desde su pedido.",
    "pedidos.pos.miss.soldOutAll": "Marcarlo agotado hasta que cierre (OJO: en todos sus tamaños)",
    "pedidos.pos.miss.drift": "Los precios de la carta subieron {amount} desde que entró el pedido.",
    "pedidos.pos.miss.err.partial": "De esto no se puede sacar solo una parte: sacalo entero.",
    "pedidos.pos.miss.err.badAdd": "Elegiste demasiadas cosas para el reemplazo.",
    "pedidos.pos.miss.err.closedNow": "{name} no se puede pedir a esta hora.",
    "pedidos.pos.miss.err.askOpen": "Primero resolvé lo que le preguntaste al cliente: {list}.",
    "pedidos.pos.toast.modified": "Listo: el pedido de {name} quedó en {total}. Aceptalo cuando quieras.",
    "pedidos.pos.cobro.transferUnverified": "La transferencia todavía no figura como recibida. Fijate en el banco antes de cobrarla como transferencia.",
    "pedidos.pos.cobro.transferArrived": "Ya llegó",
    "pedidos.pos.cobro.otherMethod": "Cobrar con otro medio",
    "pedidos.pos.cobro.feeQ": "¿Cuánto fue el envío?",
    "pedidos.pos.cobro.feeHint": "El cliente lo pidió con envío a coordinar. Si lo cobraste, ponelo acá y entra en la caja y en el reporte de envíos. Si no, dejalo en 0.",
    "pedidos.pos.cobro.feeAdded": "Se suman {fee} de envío a los {base} del pedido.",
    "pedidos.pos.cobro.feeSplit": "Lo del pedido va por {method} y el envío en efectivo, que es como suele cobrarlo el cadete. Si lo pagó de otra forma, cambiá el medio abajo.",
    "pedidos.pos.card.promised": "Prometido para las {time}",
    "pedidos.pos.card.promisedHint": "Lo antes posible: al cliente le prometimos las {time}.",
    "pedidos.pos.printer.none": "Comandera: no hay ninguna conectada. Los pedidos se ven en pantalla, pero no sale el papel para la cocina.",
    "pedidos.pos.printer.ok": "Hay una comandera conectada para los pedidos.",

    "pedidos.pos.expired.title": "Vencidos sin respuesta ({n})",
    "pedidos.pos.expired.show": "Ver",
    "pedidos.pos.expired.hide": "Ocultar",
    "pedidos.pos.expired.wa": "Hola {name}, te escribimos por tu pedido {code}. Perdón por no responder a tiempo: ¿lo seguís queriendo?",

    "pedidos.pos.banner.newOne": "Pedido online de {name} · {total}",
    "pedidos.pos.banner.newMany": "{n} pedidos online esperando respuesta",
    "pedidos.pos.banner.see": "Ver",
    "pedidos.pos.banner.soundLocked": "El aviso de pedidos online está en silencio en esta pantalla.",
    "pedidos.pos.banner.soundCta": "Tocá para activar el sonido",
    "pedidos.pos.banner.soundLockedOpen": "El aviso de pedidos online está en silencio en esta pantalla. Si ninguna pantalla suena, en {min} min la tienda se cierra para los clientes.",
    "pedidos.pos.banner.offline": "Sin conexión: los pedidos online no se pueden aceptar. Si alguien está esperando, llamalo.",
    "pedidos.pos.banner.noInternet": "La PC no tiene internet: los pedidos online no llegan. Atendé por WhatsApp o por teléfono hasta que vuelva.",
    "pedidos.pos.banner.noInternetBoot": "La PC arrancó sin internet: los pedidos online no llegan hasta que se conecte. Atendé por WhatsApp o por teléfono.",
    "pedidos.pos.banner.attention": "Vencieron pedidos sin que nadie los viera. ¿Seguís tomando pedidos online?",
    "pedidos.pos.banner.attentionYes": "Sí, sigo",
    "pedidos.pos.banner.autoPaused": "La tienda online se cerró sola porque nadie respondía los pedidos.",
    "pedidos.pos.banner.catalogIssue": "La carta tiene un problema y la tienda online no toma pedidos. Revisala en el editor.",
    "pedidos.pos.banner.waitingOne": "El pedido de {name} sigue esperando respuesta · vence en {min} min",
    "pedidos.pos.banner.waitingMany": "{n} pedidos online siguen esperando respuesta · el primero vence en {min} min",
    "pedidos.pos.nav.badge": "{n} pedidos online esperando",
    "pedidos.pos.list.web": "WEB",

    "pedidos.pos.paper.web": "WEB",
    "pedidos.pos.paper.client": "Cliente: {name}",
    "pedidos.pos.paper.webCode": "Pedido web {code}",
    "pedidos.pos.paper.verifyTransfer": "VERIFICAR LA TRANSFERENCIA ANTES DE ENTREGAR",
    "pedidos.pos.paper.transferReceived": "TRANSFERENCIA RECIBIDA",
    "pedidos.pos.paper.transferAmount": "TRANSFERENCIA {amount}",
    "pedidos.pos.paper.feeCoordinate": "Envío: a coordinar",
    "pedidos.pos.paper.ref": "Ref. (cliente): {ref}",
    "pedidos.pos.paper.promised": "PROMETIDO {time}",
    "pedidos.pos.paper.feeCoordinateHint": "(aparte: no está en el total ni en el vuelto)",
    "pedidos.pos.paper.testTag": "PRUEBA - NO COCINAR",
    "pedidos.pos.paper.testTop": "PEDIDO DE PRUEBA - NO ENTREGAR",
    "pedidos.pos.paper.testBottom": "Es una prueba: no se cobra ni queda en la caja",
    "pedidos.pos.paper.testLabel": "PRUEBA",
    "pedidos.pos.cashLabel": "Descuento efectivo",

    "pedidos.pos.toast.printed": "{order}: aceptado · mandando a la cocina…",
    "pedidos.pos.toast.awaitingPay": "{order}: aceptado. El cliente ve tu alias; la comanda sale cuando toques «Llegó la transferencia».",
    "pedidos.pos.toast.paidPrinted": "{order}: llegó la transferencia · mandando a la cocina…",
    "pedidos.pos.toast.paidNoPrinter": "Llegó la transferencia de {name}, pero no hay comandera: la comanda NO salió. Revisá la impresora y tocá «Armar e imprimir» en la tarjeta.",
    "pedidos.pos.toast.built": "{order}: aceptado. Revisalo y mandalo a cocina.",
    "pedidos.pos.toast.mismatch": "{order}: el total no coincide ({got} acá, {expected} el cliente). No se imprimió: revisalo antes de mandarlo.",
    "pedidos.pos.toast.lost": "El pedido de {name} ya lo aceptó otro equipo.",
    "pedidos.pos.toast.builtElsewhere": "{order}: ya lo armó otro equipo.",
    "pedidos.pos.toast.leaseHeld": "Otro equipo está armando este pedido. Probá en unos segundos.",
    "pedidos.pos.toast.expired": "El pedido de {name} venció antes de aceptarlo: el cliente ya puede estar pidiendo por WhatsApp.",
    "pedidos.pos.toast.gone": "Ese pedido ya no está esperando (lo canceló el cliente o lo respondió otro equipo).",
    "pedidos.pos.toast.testPrinted": "Prueba aceptada: mirá la comanda y la bolsa. No quedó nada en la caja.",
    "pedidos.pos.toast.testNoPrinter": "La prueba se aceptó pero no hay ninguna comandera conectada: no salió ningún papel.",
    "pedidos.pos.toast.testDiscarded": "Prueba descartada.",
    "pedidos.pos.toast.offline": "Sin conexión: no se pudo aceptar el pedido de {name}. Llamalo al {phone}.",
    "pedidos.pos.toast.buildError": "No se pudo armar el pedido de {name} ({code}). Atendelo por WhatsApp o cancelalo desde la tarjeta; si se repite, recargá la página.",
    "pedidos.pos.toast.orderClosed": "La orden de ese pedido ya está cobrada o anulada.",
    "pedidos.pos.toast.error": "No se pudo hacer ({code}). Probá de nuevo.",
    "pedidos.pos.toast.rejected": "Rechazaste el pedido de {name}.",
    "pedidos.pos.toast.rejectedSoldOut": "Rechazaste el pedido de {name} y marcaste {n} agotado(s) hasta que cierres.",
    "pedidos.pos.toast.ready": "Le avisamos a {name} que está listo.",
    "pedidos.pos.toast.out": "Le avisamos a {name} que va en camino.",
    "pedidos.pos.toast.paid": "Transferencia de {name} marcada como recibida.",
    "pedidos.pos.toast.done": "Pedido de {name} entregado.",
    "pedidos.pos.toast.canceled": "Cancelaste el pedido de {name}.",
    "pedidos.pos.toast.amended": "{name} ya ve el total nuevo.",
    "pedidos.pos.toast.actionOffline": "Sin conexión con la nube: no se pudo avisar. Probá de nuevo en un rato.",
    "pedidos.pos.toast.orderLinked": "Ese pedido ya tiene su orden: cobrala o anulala desde el pedido.",
    "pedidos.pos.toast.aboveCeiling": "Es más de lo que confirmó el cliente ({max}): tocá «El cliente aceptó» solo si lo hablaste con él.",
    "pedidos.pos.toast.storeOpen": "Tienda online abierta: ya pueden pedir.",
    "pedidos.pos.toast.storeOpenWa": "Tienda abierta, pero los pedidos de tu link llegan por WhatsApp (no a esta bandeja). Para recibirlos acá, elegí «Recibirlos en Comandas» en la configuración de pedidos online.",
    "pedidos.pos.toast.storeClosed": "Tienda online cerrada.",
    "pedidos.pos.toast.storePaused": "Tienda online en pausa.",
    "pedidos.pos.toast.soldOutSaved": "Marcado como agotado.",
    "pedidos.pos.toast.noPrinter": "{order}: aceptado, pero NO salió a la cocina: no hay comandera disponible. Revisá la impresora y tocá «Enviar» en el pedido.",
    // Los avisos de "la comanda no salió" de un pedido que NO es de mesa (envío, retiro, apps): sin el
    // "MESA" adelante. {table} = "Envío #4 · Juana Pérez" (orderNoticeName). Ver TEXTO_SIN_MESA.
    "pedidos.pos.print.failedTable": "{table}: la comanda NO salió. Esos platos volvieron a pendientes: revisá la comandera y tocá Enviar de nuevo.",
    "pedidos.pos.print.failedMixed": "{table}: parte de la comanda no salió y volvió a pendientes, y otra parte no se pudo confirmar. Fijate en las comanderas antes de reimprimir.",
    "pedidos.pos.print.failedReprint": "{table}: la comanda NO salió. Revisá la comandera y reimprimí la comanda completa.",
    "pedidos.pos.print.failedTableClosed": "{table}: la comanda NO salió y el pedido ya se cerró. Fijate si falta hacer ese pedido.",
    "pedidos.pos.print.unconfirmedTable": "{table}: no pudimos confirmar la impresión. Fijate en la comandera ANTES de reimprimir: puede haber salido igual.",
    "pedidos.pos.print.chargedDone": "{table}: cobrado ✓",
    "pedidos.pos.print.voidDone": "{table}: anulado",
    "pedidos.pos.toast.cannotBuild": "El pedido de {name} no se puede armar en esta pantalla ({code}). No lo aceptes: rechazalo o atendelo por WhatsApp. Si se repite, recargá la página.",
    "pedidos.pos.toast.notReady": "Todavía se están cargando los pedidos de hoy. Probá de nuevo en un segundo.",
    "pedidos.pos.toast.acceptUnknown": "Se cortó la conexión y no sabemos si se aceptó el pedido de {name}. NO lo cargues a mano: cuando vuelva la conexión, la tarjeta muestra cómo quedó.",
    "pedidos.pos.toast.acceptedNotBuilt": "El pedido de {name} quedó ACEPTADO pero todavía no salió a la cocina (se cortó la conexión). Cuando vuelva, tocá «Armar e imprimir» o «Mandar a cocina» en la tarjeta. No lo cargues a mano.",
    "pedidos.pos.toast.rejectOffline": "Sin conexión: no se pudo rechazar el pedido de {name}. Si no vuelve la conexión, avisale al {phone}.",
    "pedidos.pos.toast.rejectUnknown": "Se cortó la conexión y no sabemos si se rechazó el pedido de {name}. Cuando vuelva, la tarjeta muestra cómo quedó.",
    "pedidos.pos.toast.saveError": "Se aceptó el pedido de {name}, pero no se pudo guardar la orden ({code}). Tocá «Armar e imprimir» en la tarjeta para reintentar. No lo cargues a mano.",
    "pedidos.pos.toast.actionUnknown": "Se cortó la conexión y no sabemos si se hizo. Mirá cómo quedó el pedido y, si hace falta, probá de nuevo.",
    "pedidos.pos.toast.tellKitchen": "Avisale a la cocina: {table} se canceló (no hay comandera para imprimir la anulación).",
    "pedidos.pos.toast.resend": "Reenviar a cocina",

    "pedidos.pos.gate.off": "Los pedidos online todavía no están habilitados para tu local.",
    "pedidos.pos.gate.noPack": "La tienda online necesita el pack Gestión activo.",
    "pedidos.pos.gate.disabled": "La tienda online está apagada en la configuración.",
    "pedidos.pos.gate.notConfigured": "Falta completar la configuración (WhatsApp, medios de pago o tipo de pedido).",
    "pedidos.pos.gate.noHours": "Falta confirmar el horario en la configuración de la tienda online.",
    "pedidos.pos.gate.outOfHours": "Abriste la tienda, pero estás fuera de horario: va a tomar pedidos cuando abras.",
    "pedidos.pos.gate.paused": "La tienda está en pausa.",
    "pedidos.pos.gate.noPresence": "Abierta, pero ninguna pantalla con sonido está atenta: activá el sonido acá.",
    "pedidos.pos.gate.catalog": "La carta tiene un problema: los clientes no pueden pedir hasta que la arregles.",
    "pedidos.pos.gate.closed": "La tienda sigue cerrada.",
    "pedidos.pos.gate.unknown": "La tienda no está tomando pedidos. Revisá la configuración.",
  },
  en: {
    "pedidos.pos.title.one": "Online order",
    "pedidos.pos.title.many": "Online orders",

    "pedidos.pos.section.title": "Online orders ({n})",
    "pedidos.pos.section.hint": "Orders your customers place on the web land here.",
    "pedidos.pos.section.hintPending": "Answer before they expire: {n} waiting.",
    "pedidos.pos.section.hintLink": "Your ordering link: {link}",
    "pedidos.pos.section.emptyOpen": "No orders yet. When one comes in, it rings and shows up here.",
    "pedidos.pos.section.emptyClosed": "The online store is closed: no orders until you open it.",
    "pedidos.pos.section.emptyOpenMuted": "No orders yet. This screen doesn't ring: check it every now and then.",
    "pedidos.pos.section.notListening": "This screen doesn't alert you to orders. If no other screen rings, the store isn't taking orders.",
    "pedidos.pos.section.notListeningIdle": "Nobody has touched this screen in over 2 hours: tap it so it keeps alerting you to orders. If no other screen rings, the store isn't taking orders.",
    "pedidos.pos.section.notListeningNoTouch": "Tap this screen once so it alerts you to orders. If no other screen rings, the store isn't taking orders.",
    "pedidos.pos.section.full": "Full: no new orders come in until you answer ({n}/{max} waiting).",
    "pedidos.pos.section.listenHere": "Ring here",

    "pedidos.pos.store.open": "Taking orders",
    "pedidos.pos.store.pausedUntil": "Paused until {time}",
    "pedidos.pos.store.autoClosed": "Closed by itself",
    "pedidos.pos.store.closed": "Store closed",
    "pedidos.pos.store.pause": "Pause",
    "pedidos.pos.store.pause30": "Pause 30 min",
    "pedidos.pos.store.pause60": "Pause 1 hour",
    "pedidos.pos.store.pauseNext": "Until it opens again",
    "pedidos.pos.store.close": "Close the store",
    "pedidos.pos.store.resume": "Resume",
    "pedidos.pos.store.openNow": "Open the store",

    "pedidos.pos.sound.on": "Rings here",
    "pedidos.pos.sound.off": "Silent here",
    "pedidos.pos.sound.hint": "Whether the order alert rings on this screen. It comes off on waiters' phones.",

    "pedidos.pos.card.kindEnvio": "Delivery",
    "pedidos.pos.card.kindRetiro": "Pickup",
    "pedidos.pos.card.noName": "No name",
    "pedidos.pos.card.agoNow": "just now",
    "pedidos.pos.card.agoMin": "{n} min ago",
    "pedidos.pos.card.agoHour": "{h} h {m} min ago",
    "pedidos.pos.card.riskNew": "New customer",
    "pedidos.pos.card.riskPrior": "Ordered {n} before",
    "pedidos.pos.card.riskFailed": "{n} not completed",
    "pedidos.pos.card.toBuild": "It was accepted but never built or printed.",
    "pedidos.pos.card.itemsAria": "{n} items",
    "pedidos.pos.card.itemsAriaOne": "{n} item",
    "pedidos.pos.card.more": "and {n} more",
    "pedidos.pos.card.payTransfer": "Bank transfer: check it before handing over",
    "pedidos.pos.card.payTransferWait": "Bank transfer: cooked once it arrives",
    "pedidos.pos.card.acceptNote": "Accepting sends the ticket to the kitchen and the customer sees “Confirmed · arrives {time}”.",
    "pedidos.pos.card.acceptNotePickup": "Accepting sends the ticket to the kitchen and the customer sees “Confirmed · pick it up at {time}”.",
    "pedidos.pos.card.acceptNoteWait": "Accepting does NOT send it to the kitchen: the customer sees your alias to transfer. The ticket goes out when you tap “Transfer arrived”.",
    "pedidos.pos.card.toBuildPaid": "The transfer arrived, but the ticket has not gone to the kitchen yet.",
    "pedidos.pos.card.payCashExact": "Cash, exact amount",
    "pedidos.pos.card.payCashWith": "Cash, pays with {amount} (change {change})",
    "pedidos.pos.card.payCashShort": "Cash, says they pay with {amount}: not enough",
    "pedidos.pos.card.payCash": "Cash",
    "pedidos.pos.card.noAddress": "No address",
    "pedidos.pos.card.pinAt": "pin at {km}",
    "pedidos.pos.card.fee": "delivery {amount}",
    "pedidos.pos.card.cash": "Cash discount {pct}%: −{amount} (already in the total)",
    "pedidos.pos.card.feeFree": "free delivery",
    "pedidos.pos.card.feeCoordinate": "delivery fee to be agreed",
    "pedidos.pos.card.testBadge": "TEST",
    "pedidos.pos.card.testHint": "A test order you sent yourself: accept it to see the kitchen ticket and the bag ticket. It isn't charged and doesn't go into the till.",
    "pedidos.pos.card.testHintBuilt": "Accepted test that didn't finish printing. Print it or discard it: it doesn't go into the till.",
    "pedidos.pos.card.testDiscard": "Discard",
    "pedidos.pos.card.testPrint": "Print the test",
    "pedidos.pos.card.testNoPrinterQ": "No kitchen printer is connected: the test can't print. Connect one and accept it again, or discard it.",
    "pedidos.pos.card.map": "Map",
    "pedidos.pos.card.pinFar": "The map pin is {km} away from the written address: confirm it with the customer.",
    "pedidos.pos.card.pinMismatch": "The address and the map pin don't match: confirm it with the customer.",
    "pedidos.pos.card.soldOut": "Out of stock: {list}",
    "pedidos.pos.card.etaAria": "Wait in minutes",
    "pedidos.pos.card.accept": "Accept · {min} min",
    "pedidos.pos.card.accepting": "Accepting…",
    "pedidos.pos.card.reject": "Reject",
    "pedidos.pos.card.acceptNoPrint": "Accept without printing",
    "pedidos.pos.card.expiresIn": "expires in {time}",
    "pedidos.pos.card.expiresNow": "expiring…",
    "pedidos.pos.card.build": "Build and print",
    "pedidos.pos.card.building": "Building…",
    "pedidos.pos.card.leaseOther": "Another device is building it. Wait a few seconds.",
    "pedidos.pos.card.call": "Call",
    "pedidos.pos.card.whatsapp": "WhatsApp",
    "pedidos.pos.card.view": "View",
    "pedidos.pos.card.cannotBuild": "This screen can't build this order. Don't accept it: reject it or handle it on WhatsApp (if it keeps happening, reload the page).",
    "pedidos.pos.card.noPrinterQ": "There's no kitchen printer available: if you accept it, no ticket goes to the kitchen. Accept it without printing?",
    "pedidos.pos.card.noPrinterBuildQ": "There's no kitchen printer available: no ticket will go to the kitchen. Build it without printing?",
    "pedidos.pos.card.buildNoPrint": "Build without printing",
    "pedidos.pos.card.cancel": "Cancel (we'll tell the customer)",
    "pedidos.pos.card.cancelConfirm": "Sure? Tap again to cancel",
    "pedidos.pos.card.ref": "Customer's note: {ref}",
    "pedidos.pos.card.payClaim": "The customer wrote something about the payment: check how they pay before handing it over.",

    "pedidos.pos.reject.why": "Why are you rejecting it? (the customer sees it)",
    "pedidos.pos.reject.sin_stock": "Out of stock",
    "pedidos.pos.reject.cerrado": "We're closing",
    "pedidos.pos.reject.fuera_de_zona": "Outside delivery area",
    "pedidos.pos.reject.demora": "Too busy",
    "pedidos.pos.reject.otro": "Other reason",
    "pedidos.pos.reject.soldOutQ": "What ran out? We'll stop it from being ordered until you close today.",
    "pedidos.pos.reject.confirmSoldOut": "Reject and mark {n} sold out",
    "pedidos.pos.reject.confirmPlain": "Reject without marking anything",
    "pedidos.pos.reject.back": "Back",

    "pedidos.pos.live.accepted": "Confirmed",
    "pedidos.pos.live.ready": "Ready",
    "pedidos.pos.live.readyPickup": "Ready for pickup",
    "pedidos.pos.live.out": "On the way",
    "pedidos.pos.live.items": "{n} items",
    "pedidos.pos.live.itemsOne": "{n} item",
    "pedidos.pos.live.eta": "we said {time}",
    "pedidos.pos.live.paid": "Transfer received ✓",
    "pedidos.pos.live.verify": "Waiting for the transfer",
    "pedidos.pos.live.unsent": "Not sent to the kitchen",
    "pedidos.pos.live.amendQ": "The order changed: the customer sees {from} and now it's {to}.",
    "pedidos.pos.live.amend": "Tell them the new total",
    "pedidos.pos.live.amendOk": "The customer agreed to {to}",
    "pedidos.pos.live.markReady": "It's ready",
    "pedidos.pos.live.markOut": "Sent out",
    "pedidos.pos.live.markPaid": "Transfer arrived",
    "pedidos.pos.live.open": "Open",
    "pedidos.pos.live.sendNow": "Send to the kitchen",
    "pedidos.pos.live.cancel": "Cancel",
    "pedidos.pos.live.cancelConfirm": "Cancel the order?",
    "pedidos.pos.live.acceptedAgo": "Accepted {ago}",
    "pedidos.pos.live.more": "Show actions",
    "pedidos.pos.live.less": "Hide actions",
    "pedidos.pos.live.charge": "Charge {total}",
    "pedidos.pos.live.seesReady": "Customer: “Ready”",
    "pedidos.pos.live.seesReadyPickup": "Customer: “Ready for pickup”",
    "pedidos.pos.live.seesOut": "Customer: “On the way”",
    "pedidos.pos.live.seesPaid": "Customer: “Transfer received”",
    "pedidos.pos.live.seesDone": "Customer: “Delivered”",
    "pedidos.pos.live.seesPickedUp": "Customer: “Picked up”",
    "pedidos.pos.live.chargeDelivered": "Delivered · charge",
    "pedidos.pos.live.chargePickedUp": "Picked up · charge",
    "pedidos.pos.live.bagVerify": "Bag ticket says CHECK: it arrived",
    "pedidos.pos.live.reprintBag": "Reprint bag ticket",
    "pedidos.pos.live.webCodeTitle": "Web order {code}: the code the customer sees",
    "pedidos.pos.await.chip": "Not cooking · waiting for the transfer until {time}",
    "pedidos.pos.await.chipNoTime": "Not cooking · waiting for the transfer · {n} min",
    "pedidos.pos.await.chipLate": "Not cooking · transfer not in · {n} min",
    "pedidos.pos.await.arrivedSees": "Ticket goes out · customer: “Transfer received”",
    "pedidos.pos.await.wa": "Hi {name}, were you able to transfer {amount} to {alias}? We will prepare your order {code} as soon as it arrives.",
    "pedidos.pos.await.cancelLate": "No transfer · cancel",
    "pedidos.pos.await.cancelConfirm": "Cancel? Customer sees “The transfer did not arrive”",
    "pedidos.pos.await.cancelConfirmEarly": "Cancel? Customer sees “The restaurant canceled the order”",
    "pedidos.pos.await.late": "{n} min and the transfer has not arrived: message them, or cancel it (the customer sees “The transfer did not arrive”).",
    "pedidos.pos.amend.added": "Added: {list}",
    "pedidos.pos.amend.removed": "Removed: {list}",
    "pedidos.pos.amend.discount": "Discount",
    "pedidos.pos.amend.charge": "Surcharge",
    "pedidos.pos.amend.fee": "Delivery {amount}",
    "pedidos.pos.miss.open": "Something's missing",
    "pedidos.pos.miss.title": "Something's missing from the order",
    "pedidos.pos.miss.q": "What don't you have?",
    "pedidos.pos.miss.howMany": "Missing",
    "pedidos.pos.miss.ofN": "of {n}",
    "pedidos.pos.miss.soldOut": "Mark it sold out until closing (so nobody else orders it)",
    "pedidos.pos.miss.without": "Remove it and continue",
    "pedidos.pos.miss.swap": "Swap for…",
    "pedidos.pos.miss.ask": "Ask the customer",
    "pedidos.pos.miss.askHint": "The customer sees it on their order page and gets a WhatsApp to choose: go on without it, swap it or cancel.",
    "pedidos.pos.miss.swapQ": "What do you swap it for? (instead of {list})",
    "pedidos.pos.miss.search": "Search the menu…",
    "pedidos.pos.miss.noResults": "Nothing with that name.",
    "pedidos.pos.miss.seeIt": "See how it looks",
    "pedidos.pos.miss.looksLike": "The order will be:",
    "pedidos.pos.miss.newTotal": "New total {total} (was {before})",
    "pedidos.pos.miss.customerOk": "The customer agreed to pay {total}",
    "pedidos.pos.miss.confirm": "Confirm the change",
    "pedidos.pos.miss.saving": "Saving…",
    "pedidos.pos.miss.afterNote": "Then accept it as usual: the kitchen gets the new order and the customer sees the new total.",
    "pedidos.pos.miss.priceChanged": "The total just changed (menu prices): check it and confirm again.",
    "pedidos.pos.miss.needsOk": "It costs more than what they ordered: confirm the customer agreed.",
    "pedidos.pos.miss.resend": "Resend WhatsApp",
    "pedidos.pos.miss.resolve": "Solve it without the customer",
    "pedidos.pos.miss.waiting": "You asked {name} what to do without {list}",
    "pedidos.pos.miss.noAnswer": "{name} didn't answer what to do without {list}",
    "pedidos.pos.miss.answerIn": "answers within {time}",
    "pedidos.pos.miss.answerSwap": "{name} chose to swap {removed} for {added}.",
    "pedidos.pos.miss.answerWithout": "{name} chose to go on without {removed}.",
    "pedidos.pos.miss.changed": "Order changed: {list}.",
    "pedidos.pos.miss.without1": "without {list}",
    "pedidos.pos.miss.with1": "with {list}",
    "pedidos.pos.miss.before": "(was {total})",
    "pedidos.pos.miss.waHi": "Hi!",
    "pedidos.pos.miss.waHiName": "Hi {name}!",
    "pedidos.pos.miss.waMsg": "{hi} This is {local} about your order #{code}. We're out of {items} 😕 Do you want to swap it for something else or go on without it? Choose here: {link}",
    "pedidos.pos.miss.err.noCart": "This order is from before this feature: accept it and change it from the order.",
    "pedidos.pos.miss.err.empty": "Nothing would be left: if you have nothing they ordered, reject it.",
    "pedidos.pos.miss.err.stale": "The order just changed (did the customer answer?): check it.",
    "pedidos.pos.miss.err.gone": "This order is no longer waiting for an answer.",
    "pedidos.pos.miss.err.catalog": "Couldn't read the menu: try again.",
    "pedidos.pos.miss.err.tooMany": "This order was already changed several times: accept it and change it from the order, or reject it.",
    "pedidos.pos.miss.err.offline": "No connection: try again.",
    "pedidos.pos.miss.err.generic": "Couldn't change the order ({code}).",
    "pedidos.pos.miss.err.soldOut": "{name} is sold out.",
    "pedidos.pos.miss.err.paused": "{name} can't be ordered online right now.",
    "pedidos.pos.miss.err.productGone": "{name} is no longer on the online menu.",
    "pedidos.pos.miss.err.options": "{name} has options to choose: ask the customer to pick it from their order page.",
    "pedidos.pos.miss.soldOutAll": "Mark it sold out until closing (NOTE: in all its sizes)",
    "pedidos.pos.miss.drift": "Menu prices went up {amount} since the order came in.",
    "pedidos.pos.miss.err.partial": "You can't remove just part of this: remove it entirely.",
    "pedidos.pos.miss.err.badAdd": "You chose too many things for the replacement.",
    "pedidos.pos.miss.err.closedNow": "{name} can't be ordered at this time.",
    "pedidos.pos.miss.err.askOpen": "First solve what you asked the customer: {list}.",
    "pedidos.pos.toast.modified": "Done: {name}'s order is now {total}. Accept it whenever you're ready.",
    "pedidos.pos.cobro.transferUnverified": "The transfer isn't marked as received yet. Check the bank before charging it as a transfer.",
    "pedidos.pos.cobro.transferArrived": "It arrived",
    "pedidos.pos.cobro.otherMethod": "Charge with another method",
    "pedidos.pos.cobro.feeQ": "How much was the delivery fee?",
    "pedidos.pos.cobro.feeHint": "The customer ordered with the delivery fee to be agreed. If you charged it, enter it here and it goes into the till and the delivery report. If not, leave it at 0.",
    "pedidos.pos.cobro.feeAdded": "{fee} delivery fee added to the order's {base}.",
    "pedidos.pos.cobro.feeSplit": "The order goes to {method} and the delivery fee to cash, which is how the driver usually collects it. If it was paid another way, change the method below.",
    "pedidos.pos.card.promised": "Promised for {time}",
    "pedidos.pos.card.promisedHint": "As soon as possible: we promised the customer {time}.",
    "pedidos.pos.printer.none": "Kitchen printer: none connected. Orders show on screen, but no ticket prints for the kitchen.",
    "pedidos.pos.printer.ok": "A kitchen printer is connected for orders.",

    "pedidos.pos.expired.title": "Expired without an answer ({n})",
    "pedidos.pos.expired.show": "Show",
    "pedidos.pos.expired.hide": "Hide",
    "pedidos.pos.expired.wa": "Hi {name}, we're writing about your order {code}. Sorry we didn't answer in time: do you still want it?",

    "pedidos.pos.banner.newOne": "Online order from {name} · {total}",
    "pedidos.pos.banner.newMany": "{n} online orders waiting for an answer",
    "pedidos.pos.banner.see": "See",
    "pedidos.pos.banner.soundLocked": "The online order alert is muted on this screen.",
    "pedidos.pos.banner.soundCta": "Tap to turn the sound on",
    "pedidos.pos.banner.soundLockedOpen": "The online order alert is muted on this screen. If no screen rings, in {min} min the store closes for customers.",
    "pedidos.pos.banner.offline": "No connection: online orders can't be accepted. If someone is waiting, call them.",
    "pedidos.pos.banner.noInternet": "This PC has no internet: online orders aren't coming in. Take orders by WhatsApp or phone until it's back.",
    "pedidos.pos.banner.noInternetBoot": "This PC started without internet: online orders won't come in until it connects. Take orders by WhatsApp or phone.",
    "pedidos.pos.banner.attention": "Orders expired without anyone seeing them. Are you still taking online orders?",
    "pedidos.pos.banner.attentionYes": "Yes, keep going",
    "pedidos.pos.banner.autoPaused": "The online store closed by itself because nobody was answering orders.",
    "pedidos.pos.banner.catalogIssue": "The menu has a problem and the online store isn't taking orders. Check it in the editor.",
    "pedidos.pos.banner.waitingOne": "{name}'s order is still waiting for an answer · expires in {min} min",
    "pedidos.pos.banner.waitingMany": "{n} online orders are still waiting for an answer · the first expires in {min} min",
    "pedidos.pos.nav.badge": "{n} online orders waiting",
    "pedidos.pos.list.web": "WEB",

    "pedidos.pos.paper.web": "WEB",
    "pedidos.pos.paper.client": "Customer: {name}",
    "pedidos.pos.paper.webCode": "Web order {code}",
    "pedidos.pos.paper.verifyTransfer": "CHECK THE TRANSFER BEFORE HANDING OVER",
    "pedidos.pos.paper.transferReceived": "TRANSFER RECEIVED",
    "pedidos.pos.paper.transferAmount": "TRANSFER {amount}",
    "pedidos.pos.paper.feeCoordinate": "Delivery fee: to be agreed",
    "pedidos.pos.paper.ref": "Note (customer): {ref}",
    "pedidos.pos.paper.promised": "PROMISED {time}",
    "pedidos.pos.paper.feeCoordinateHint": "(separate: not in the total or the change)",
    "pedidos.pos.paper.testTag": "TEST - DO NOT COOK",
    "pedidos.pos.paper.testTop": "TEST ORDER - DO NOT DELIVER",
    "pedidos.pos.paper.testBottom": "This is a test: not charged, not in the till",
    "pedidos.pos.paper.testLabel": "TEST",
    "pedidos.pos.cashLabel": "Cash discount",

    "pedidos.pos.toast.printed": "{order}: accepted · sending to the kitchen…",
    "pedidos.pos.toast.awaitingPay": "{order}: accepted. The customer sees your alias; the ticket goes out when you tap “Transfer arrived”.",
    "pedidos.pos.toast.paidPrinted": "{order}: transfer arrived · sending to the kitchen…",
    "pedidos.pos.toast.paidNoPrinter": "{name}'s transfer arrived, but there is no printer: the ticket did NOT go out. Check the printer and tap “Build and print” on the card.",
    "pedidos.pos.toast.built": "{order}: accepted. Review it and send it to the kitchen.",
    "pedidos.pos.toast.mismatch": "{order}: the total doesn't match ({got} here, {expected} for the customer). Not printed: review it before sending.",
    "pedidos.pos.toast.lost": "Another device already accepted {name}'s order.",
    "pedidos.pos.toast.builtElsewhere": "{order}: another device already built it.",
    "pedidos.pos.toast.leaseHeld": "Another device is building this order. Try again in a few seconds.",
    "pedidos.pos.toast.expired": "{name}'s order expired before it was accepted: they may be ordering by WhatsApp already.",
    "pedidos.pos.toast.gone": "That order is no longer waiting (the customer canceled it or another device answered).",
    "pedidos.pos.toast.testPrinted": "Test accepted: check the kitchen ticket and the bag ticket. Nothing went into the till.",
    "pedidos.pos.toast.testNoPrinter": "The test was accepted but no kitchen printer is connected: nothing printed.",
    "pedidos.pos.toast.testDiscarded": "Test discarded.",
    "pedidos.pos.toast.offline": "No connection: {name}'s order couldn't be accepted. Call them at {phone}.",
    "pedidos.pos.toast.buildError": "{name}'s order couldn't be built ({code}). Handle it on WhatsApp or cancel it from the card; if it keeps happening, reload the page.",
    "pedidos.pos.toast.orderClosed": "That order is already paid or voided.",
    "pedidos.pos.toast.error": "It couldn't be done ({code}). Try again.",
    "pedidos.pos.toast.rejected": "You rejected {name}'s order.",
    "pedidos.pos.toast.rejectedSoldOut": "You rejected {name}'s order and marked {n} sold out until closing.",
    "pedidos.pos.toast.ready": "We told {name} it's ready.",
    "pedidos.pos.toast.out": "We told {name} it's on the way.",
    "pedidos.pos.toast.paid": "{name}'s transfer marked as received.",
    "pedidos.pos.toast.done": "{name}'s order delivered.",
    "pedidos.pos.toast.canceled": "You canceled {name}'s order.",
    "pedidos.pos.toast.amended": "{name} now sees the new total.",
    "pedidos.pos.toast.actionOffline": "No connection to the cloud: couldn't notify. Try again in a while.",
    "pedidos.pos.toast.orderLinked": "That order already has its ticket: charge it or void it from the order.",
    "pedidos.pos.toast.aboveCeiling": "It's more than the customer confirmed ({max}): tap “The customer agreed” only if you talked to them.",
    "pedidos.pos.toast.storeOpen": "Online store open: people can order now.",
    "pedidos.pos.toast.storeOpenWa": "Store open, but orders from your link arrive by WhatsApp (not in this inbox). To get them here, choose “Receive them in Comandas” in the online orders settings.",
    "pedidos.pos.toast.storeClosed": "Online store closed.",
    "pedidos.pos.toast.storePaused": "Online store paused.",
    "pedidos.pos.toast.soldOutSaved": "Marked as sold out.",
    "pedidos.pos.toast.noPrinter": "{order}: accepted, but NOTHING went to the kitchen: no printer available. Check the printer and tap “Send” on the order.",
    // Los avisos de "la comanda no salió" de un pedido que NO es de mesa (envío, retiro, apps): sin el
    // "MESA" adelante. {table} = "Envío #4 · Juana Pérez" (orderNoticeName). Ver TEXTO_SIN_MESA.
    "pedidos.pos.print.failedTable": "{table}: the kitchen ticket did NOT print. Those items went back to pending: check the printer and tap Send again.",
    "pedidos.pos.print.failedMixed": "{table}: part of the order did not print and went back to pending, and another part could not be confirmed. Check the printers before reprinting.",
    "pedidos.pos.print.failedReprint": "{table}: the kitchen ticket did NOT print. Check the printer and reprint the full order.",
    "pedidos.pos.print.failedTableClosed": "{table}: the kitchen ticket did NOT print and the order is already closed. Check whether it still needs to be made.",
    "pedidos.pos.print.unconfirmedTable": "{table}: we could not confirm the print. Check the printer BEFORE reprinting: it may have printed anyway.",
    "pedidos.pos.print.chargedDone": "{table}: closed ✓",
    "pedidos.pos.print.voidDone": "{table}: voided",
    "pedidos.pos.toast.cannotBuild": "{name}'s order can't be built on this screen ({code}). Don't accept it: reject it or handle it on WhatsApp. If it keeps happening, reload the page.",
    "pedidos.pos.toast.notReady": "Today's orders are still loading. Try again in a second.",
    "pedidos.pos.toast.acceptUnknown": "The connection dropped and we don't know whether {name}'s order was accepted. DON'T enter it by hand: when the connection is back, the card shows how it ended up.",
    "pedidos.pos.toast.acceptedNotBuilt": "{name}'s order is ACCEPTED but hasn't gone to the kitchen yet (the connection dropped). When it's back, tap “Build and print” or “Send to kitchen” on the card. Don't enter it by hand.",
    "pedidos.pos.toast.rejectOffline": "No connection: {name}'s order couldn't be rejected. If the connection doesn't come back, let them know at {phone}.",
    "pedidos.pos.toast.rejectUnknown": "The connection dropped and we don't know whether {name}'s order was rejected. When it's back, the card shows how it ended up.",
    "pedidos.pos.toast.saveError": "{name}'s order was accepted, but its ticket couldn't be saved ({code}). Tap “Build and print” on the card to retry. Don't enter it by hand.",
    "pedidos.pos.toast.actionUnknown": "The connection dropped and we don't know whether it went through. Check the order and try again if needed.",
    "pedidos.pos.toast.tellKitchen": "Tell the kitchen: {table} was canceled (no printer available for the void ticket).",
    "pedidos.pos.toast.resend": "Resend to kitchen",

    "pedidos.pos.gate.off": "Online orders aren't enabled for your venue yet.",
    "pedidos.pos.gate.noPack": "The online store needs an active Management pack.",
    "pedidos.pos.gate.disabled": "The online store is turned off in the settings.",
    "pedidos.pos.gate.notConfigured": "The settings are incomplete (WhatsApp, payment methods or order type).",
    "pedidos.pos.gate.noHours": "The opening hours still need to be confirmed in the online store settings.",
    "pedidos.pos.gate.outOfHours": "You opened the store, but you're outside opening hours: it will take orders when you open.",
    "pedidos.pos.gate.paused": "The store is paused.",
    "pedidos.pos.gate.noPresence": "Open, but no screen with sound is paying attention: turn the sound on here.",
    "pedidos.pos.gate.catalog": "The menu has a problem: customers can't order until you fix it.",
    "pedidos.pos.gate.closed": "The store is still closed.",
    "pedidos.pos.gate.unknown": "The store isn't taking orders. Check the settings.",
  },
  pt: {
    "pedidos.pos.title.one": "Pedido online",
    "pedidos.pos.title.many": "Pedidos online",

    "pedidos.pos.section.title": "Pedidos online ({n})",
    "pedidos.pos.section.hint": "Os pedidos que seus clientes fazem pela web chegam aqui.",
    "pedidos.pos.section.hintPending": "Responda antes que expire: {n} esperando.",
    "pedidos.pos.section.hintLink": "Seu link para pedir: {link}",
    "pedidos.pos.section.emptyOpen": "Ainda não chegou nenhum pedido. Quando chegar, toca e aparece aqui.",
    "pedidos.pos.section.emptyClosed": "A loja online está fechada: não entram pedidos até você abrir.",
    "pedidos.pos.section.emptyOpenMuted": "Ainda não entrou nenhum pedido. Esta tela não toca: dê uma olhada de vez em quando.",
    "pedidos.pos.section.notListening": "Esta tela não avisa os pedidos. Se nenhuma outra tela tocar, a loja não recebe pedidos.",
    "pedidos.pos.section.notListeningIdle": "Faz mais de 2 horas que ninguém toca nesta tela: toque para ela continuar avisando os pedidos. Se nenhuma outra tocar, a loja não recebe pedidos.",
    "pedidos.pos.section.notListeningNoTouch": "Toque nesta tela uma vez para ela avisar os pedidos. Se nenhuma outra tocar, a loja não recebe pedidos.",
    "pedidos.pos.section.full": "Lotado: não entram pedidos novos até você responder ({n}/{max} esperando).",
    "pedidos.pos.section.listenHere": "Tocar aqui",

    "pedidos.pos.store.open": "Recebendo pedidos",
    "pedidos.pos.store.pausedUntil": "Pausada até {time}",
    "pedidos.pos.store.autoClosed": "Fechou sozinha",
    "pedidos.pos.store.closed": "Loja fechada",
    "pedidos.pos.store.pause": "Pausar",
    "pedidos.pos.store.pause30": "Pausar 30 min",
    "pedidos.pos.store.pause60": "Pausar 1 hora",
    "pedidos.pos.store.pauseNext": "Até abrir de novo",
    "pedidos.pos.store.close": "Fechar a loja",
    "pedidos.pos.store.resume": "Retomar",
    "pedidos.pos.store.openNow": "Abrir a loja",

    "pedidos.pos.sound.on": "Toca aqui",
    "pedidos.pos.sound.off": "Não toca aqui",
    "pedidos.pos.sound.hint": "Se o aviso de pedidos toca nesta tela. Nos celulares dos garçons vem desligado.",

    "pedidos.pos.card.kindEnvio": "Entrega",
    "pedidos.pos.card.kindRetiro": "Retirada",
    "pedidos.pos.card.noName": "Sem nome",
    "pedidos.pos.card.agoNow": "agora",
    "pedidos.pos.card.agoMin": "há {n} min",
    "pedidos.pos.card.agoHour": "há {h} h {m} min",
    "pedidos.pos.card.riskNew": "Cliente novo",
    "pedidos.pos.card.riskPrior": "Já pediu {n}",
    "pedidos.pos.card.riskFailed": "{n} não concretizados",
    "pedidos.pos.card.toBuild": "Foi aceito, mas não chegou a ser montado nem impresso.",
    "pedidos.pos.card.itemsAria": "{n} itens",
    "pedidos.pos.card.itemsAriaOne": "{n} item",
    "pedidos.pos.card.more": "e mais {n}",
    "pedidos.pos.card.payTransfer": "Transferência: confira antes de entregar",
    "pedidos.pos.card.payTransferWait": "Transferência: prepara quando chegar",
    "pedidos.pos.card.acceptNote": "Ao aceitar, a comanda vai para a cozinha e o cliente vê «Confirmado · chega {time}».",
    "pedidos.pos.card.acceptNotePickup": "Ao aceitar, a comanda vai para a cozinha e o cliente vê «Confirmado · retire às {time}».",
    "pedidos.pos.card.acceptNoteWait": "Ao aceitar NÃO vai para a cozinha: o cliente vê sua chave para transferir. A comanda sai quando você tocar «A transferência chegou».",
    "pedidos.pos.card.toBuildPaid": "A transferência chegou, mas a comanda ainda não foi para a cozinha.",
    "pedidos.pos.card.payCashExact": "Dinheiro, valor exato",
    "pedidos.pos.card.payCashWith": "Dinheiro, paga com {amount} (troco {change})",
    "pedidos.pos.card.payCashShort": "Dinheiro, diz que paga com {amount}: não dá",
    "pedidos.pos.card.payCash": "Dinheiro",
    "pedidos.pos.card.noAddress": "Sem endereço",
    "pedidos.pos.card.pinAt": "pino a {km}",
    "pedidos.pos.card.fee": "entrega {amount}",
    "pedidos.pos.card.cash": "Desconto dinheiro {pct}%: −{amount} (já está no total)",
    "pedidos.pos.card.feeFree": "entrega grátis",
    "pedidos.pos.card.feeCoordinate": "entrega a combinar",
    "pedidos.pos.card.testBadge": "TESTE",
    "pedidos.pos.card.testHint": "Pedido de teste que você mandou: aceite para ver a comanda e o ticket da sacola. Não é cobrado nem entra no caixa.",
    "pedidos.pos.card.testHintBuilt": "Teste aceito que não terminou de imprimir. Imprima ou descarte: não entra no caixa.",
    "pedidos.pos.card.testDiscard": "Descartar",
    "pedidos.pos.card.testPrint": "Imprimir o teste",
    "pedidos.pos.card.testNoPrinterQ": "Nenhuma impressora de comandas conectada: o teste não pode imprimir. Conecte uma e aceite de novo, ou descarte.",
    "pedidos.pos.card.map": "Mapa",
    "pedidos.pos.card.pinFar": "O pino do mapa fica a {km} do endereço escrito: confirme com o cliente.",
    "pedidos.pos.card.pinMismatch": "O endereço e o pino do mapa não batem: confirme com o cliente.",
    "pedidos.pos.card.soldOut": "Sem estoque: {list}",
    "pedidos.pos.card.etaAria": "Demora em minutos",
    "pedidos.pos.card.accept": "Aceitar · {min} min",
    "pedidos.pos.card.accepting": "Aceitando…",
    "pedidos.pos.card.reject": "Recusar",
    "pedidos.pos.card.acceptNoPrint": "Aceitar sem imprimir",
    "pedidos.pos.card.expiresIn": "expira em {time}",
    "pedidos.pos.card.expiresNow": "expirando…",
    "pedidos.pos.card.build": "Montar e imprimir",
    "pedidos.pos.card.building": "Montando…",
    "pedidos.pos.card.leaseOther": "Outro aparelho está montando. Espere alguns segundos.",
    "pedidos.pos.card.call": "Ligar",
    "pedidos.pos.card.whatsapp": "WhatsApp",
    "pedidos.pos.card.view": "Ver",
    "pedidos.pos.card.cannotBuild": "Esta tela não consegue montar este pedido. Não aceite: recuse ou atenda pelo WhatsApp (se repetir, recarregue a página).",
    "pedidos.pos.card.noPrinterQ": "Não há nenhuma impressora disponível: se você aceitar, não sai o papel para a cozinha. Aceitar sem imprimir?",
    "pedidos.pos.card.noPrinterBuildQ": "Não há nenhuma impressora disponível: não vai sair o papel para a cozinha. Montar sem imprimir?",
    "pedidos.pos.card.buildNoPrint": "Montar sem imprimir",
    "pedidos.pos.card.cancel": "Cancelar (avisamos o cliente)",
    "pedidos.pos.card.cancelConfirm": "Certeza? Toque de novo para cancelar",
    "pedidos.pos.card.ref": "Ref. do cliente: {ref}",
    "pedidos.pos.card.payClaim": "O cliente escreveu algo sobre o pagamento: confira como ele paga antes de entregar.",

    "pedidos.pos.reject.why": "Por que você recusa? (o cliente vê)",
    "pedidos.pos.reject.sin_stock": "Sem estoque",
    "pedidos.pos.reject.cerrado": "Estamos fechando",
    "pedidos.pos.reject.fuera_de_zona": "Fora da área",
    "pedidos.pos.reject.demora": "Muita demora",
    "pedidos.pos.reject.otro": "Outro motivo",
    "pedidos.pos.reject.soldOutQ": "O que acabou? Deixamos sem poder pedir até você fechar hoje.",
    "pedidos.pos.reject.confirmSoldOut": "Recusar e marcar {n} esgotado(s)",
    "pedidos.pos.reject.confirmPlain": "Recusar sem marcar nada",
    "pedidos.pos.reject.back": "Voltar",

    "pedidos.pos.live.accepted": "Confirmado",
    "pedidos.pos.live.ready": "Pronto",
    "pedidos.pos.live.readyPickup": "Pronto para retirar",
    "pedidos.pos.live.out": "A caminho",
    "pedidos.pos.live.items": "{n} itens",
    "pedidos.pos.live.itemsOne": "{n} item",
    "pedidos.pos.live.eta": "dissemos {time}",
    "pedidos.pos.live.paid": "Transferência recebida ✓",
    "pedidos.pos.live.verify": "Aguardando a transferência",
    "pedidos.pos.live.unsent": "Não enviado à cozinha",
    "pedidos.pos.live.amendQ": "O pedido mudou: o cliente vê {from} e agora é {to}.",
    "pedidos.pos.live.amend": "Avisar o total novo",
    "pedidos.pos.live.amendOk": "O cliente aceitou {to}",
    "pedidos.pos.live.markReady": "Está pronto",
    "pedidos.pos.live.markOut": "Saiu",
    "pedidos.pos.live.markPaid": "A transferência chegou",
    "pedidos.pos.live.open": "Abrir",
    "pedidos.pos.live.sendNow": "Mandar para a cozinha",
    "pedidos.pos.live.cancel": "Cancelar",
    "pedidos.pos.live.cancelConfirm": "Cancelar o pedido?",
    "pedidos.pos.live.acceptedAgo": "Aceito {ago}",
    "pedidos.pos.live.more": "Ver ações",
    "pedidos.pos.live.less": "Ocultar ações",
    "pedidos.pos.live.charge": "Cobrar {total}",
    "pedidos.pos.live.seesReady": "Cliente: «Pronto»",
    "pedidos.pos.live.seesReadyPickup": "Cliente: «Pronto para retirar»",
    "pedidos.pos.live.seesOut": "Cliente: «A caminho»",
    "pedidos.pos.live.seesPaid": "Cliente: «Transferência recebida»",
    "pedidos.pos.live.seesDone": "Cliente: «Entregue»",
    "pedidos.pos.live.seesPickedUp": "Cliente: «Retirado»",
    "pedidos.pos.live.chargeDelivered": "Entregue · cobrar",
    "pedidos.pos.live.chargePickedUp": "Retirou · cobrar",
    "pedidos.pos.live.bagVerify": "O ticket diz CONFERIR: já chegou",
    "pedidos.pos.live.reprintBag": "Reimprimir o ticket",
    "pedidos.pos.live.webCodeTitle": "Pedido web {code}: o código que o cliente vê",
    "pedidos.pos.await.chip": "Sem preparar · aguardando a transferência até {time}",
    "pedidos.pos.await.chipNoTime": "Sem preparar · aguardando a transferência · {n} min",
    "pedidos.pos.await.chipLate": "Sem preparar · a transferência não chegou · {n} min",
    "pedidos.pos.await.arrivedSees": "A comanda sai · cliente: «Transferência recebida»",
    "pedidos.pos.await.wa": "Olá {name}, conseguiu transferir {amount} para {alias}? Preparamos seu pedido {code} assim que chegar.",
    "pedidos.pos.await.cancelLate": "Não transferiu · cancelar",
    "pedidos.pos.await.cancelConfirm": "Cancelar? O cliente vê «A transferência não chegou»",
    "pedidos.pos.await.cancelConfirmEarly": "Cancelar? O cliente vê «O restaurante cancelou o pedido»",
    "pedidos.pos.await.late": "Passaram {n} min e a transferência não chegou: escreva para ele, ou cancele (o cliente vê «A transferência não chegou»).",
    "pedidos.pos.amend.added": "Foi adicionado: {list}",
    "pedidos.pos.amend.removed": "Foi retirado: {list}",
    "pedidos.pos.amend.discount": "Desconto",
    "pedidos.pos.amend.charge": "Acréscimo",
    "pedidos.pos.amend.fee": "Entrega {amount}",
    "pedidos.pos.miss.open": "Falta algo",
    "pedidos.pos.miss.title": "Falta algo do pedido",
    "pedidos.pos.miss.q": "O que você não tem?",
    "pedidos.pos.miss.howMany": "Faltam",
    "pedidos.pos.miss.ofN": "de {n}",
    "pedidos.pos.miss.soldOut": "Marcar esgotado até fechar (assim ninguém mais pede)",
    "pedidos.pos.miss.without": "Tirar e seguir",
    "pedidos.pos.miss.swap": "Trocar por…",
    "pedidos.pos.miss.ask": "Perguntar ao cliente",
    "pedidos.pos.miss.askHint": "O cliente vê no pedido dele e recebe um WhatsApp para escolher: seguir sem isso, trocar ou cancelar.",
    "pedidos.pos.miss.swapQ": "Trocar pelo quê? (no lugar de {list})",
    "pedidos.pos.miss.search": "Procure no cardápio…",
    "pedidos.pos.miss.noResults": "Nada com esse nome.",
    "pedidos.pos.miss.seeIt": "Ver como fica",
    "pedidos.pos.miss.looksLike": "O pedido fica assim:",
    "pedidos.pos.miss.newTotal": "Total novo {total} (antes {before})",
    "pedidos.pos.miss.customerOk": "O cliente aceitou pagar {total}",
    "pedidos.pos.miss.confirm": "Confirmar a mudança",
    "pedidos.pos.miss.saving": "Salvando…",
    "pedidos.pos.miss.afterNote": "Depois aceite como sempre: a cozinha recebe o pedido novo e o cliente vê o total novo.",
    "pedidos.pos.miss.priceChanged": "O total acabou de mudar (preços do cardápio): revise e confirme de novo.",
    "pedidos.pos.miss.needsOk": "Sai mais caro do que o pedido: confirme que o cliente aceitou.",
    "pedidos.pos.miss.resend": "Reenviar WhatsApp",
    "pedidos.pos.miss.resolve": "Resolver sem o cliente",
    "pedidos.pos.miss.waiting": "Você perguntou a {name} o que fazer sem {list}",
    "pedidos.pos.miss.noAnswer": "{name} não respondeu o que fazer sem {list}",
    "pedidos.pos.miss.answerIn": "responde em {time}",
    "pedidos.pos.miss.answerSwap": "{name} escolheu trocar {removed} por {added}.",
    "pedidos.pos.miss.answerWithout": "{name} escolheu seguir sem {removed}.",
    "pedidos.pos.miss.changed": "Pedido alterado: {list}.",
    "pedidos.pos.miss.without1": "sem {list}",
    "pedidos.pos.miss.with1": "com {list}",
    "pedidos.pos.miss.before": "(antes {total})",
    "pedidos.pos.miss.waHi": "Olá!",
    "pedidos.pos.miss.waHiName": "Olá {name}!",
    "pedidos.pos.miss.waMsg": "{hi} Aqui é {local}, sobre o seu pedido #{code}. Acabou {items} 😕 Quer trocar por outra coisa ou seguimos sem isso? Escolha aqui: {link}",
    "pedidos.pos.miss.err.noCart": "Este pedido é de antes desta função: aceite e altere pelo pedido.",
    "pedidos.pos.miss.err.empty": "Não sobraria nada: se você não tem nada do pedido, recuse.",
    "pedidos.pos.miss.err.stale": "O pedido acabou de mudar (o cliente respondeu?): revise.",
    "pedidos.pos.miss.err.gone": "Este pedido não está mais esperando resposta.",
    "pedidos.pos.miss.err.catalog": "Não deu para ler o cardápio: tente de novo.",
    "pedidos.pos.miss.err.tooMany": "Este pedido já foi alterado várias vezes: aceite e altere pelo pedido, ou recuse.",
    "pedidos.pos.miss.err.offline": "Sem conexão: tente de novo.",
    "pedidos.pos.miss.err.generic": "Não deu para alterar o pedido ({code}).",
    "pedidos.pos.miss.err.soldOut": "{name} está esgotado.",
    "pedidos.pos.miss.err.paused": "{name} não está à venda online agora.",
    "pedidos.pos.miss.err.productGone": "{name} não está mais no cardápio online.",
    "pedidos.pos.miss.err.options": "{name} tem opções para escolher: peça ao cliente que escolha pelo pedido dele.",
    "pedidos.pos.miss.soldOutAll": "Marcar esgotado até fechar (ATENÇÃO: em todos os tamanhos)",
    "pedidos.pos.miss.drift": "Os preços do cardápio subiram {amount} desde que o pedido entrou.",
    "pedidos.pos.miss.err.partial": "Não dá para tirar só uma parte disto: tire inteiro.",
    "pedidos.pos.miss.err.badAdd": "Você escolheu coisas demais para a troca.",
    "pedidos.pos.miss.err.closedNow": "{name} não pode ser pedido neste horário.",
    "pedidos.pos.miss.err.askOpen": "Primeiro resolva o que você perguntou ao cliente: {list}.",
    "pedidos.pos.toast.modified": "Pronto: o pedido de {name} ficou em {total}. Aceite quando quiser.",
    "pedidos.pos.cobro.transferUnverified": "A transferência ainda não consta como recebida. Confira no banco antes de cobrá-la como transferência.",
    "pedidos.pos.cobro.transferArrived": "Já chegou",
    "pedidos.pos.cobro.otherMethod": "Cobrar com outro meio",
    "pedidos.pos.cobro.feeQ": "Quanto foi a entrega?",
    "pedidos.pos.cobro.feeHint": "O cliente pediu com a entrega a combinar. Se você cobrou, coloque aqui e entra no caixa e no relatório de entregas. Se não, deixe em 0.",
    "pedidos.pos.cobro.feeAdded": "Somam-se {fee} de entrega aos {base} do pedido.",
    "pedidos.pos.cobro.feeSplit": "O pedido vai por {method} e a entrega em dinheiro, que é como o entregador costuma cobrar. Se foi pago de outro jeito, troque o meio abaixo.",
    "pedidos.pos.card.promised": "Prometido para as {time}",
    "pedidos.pos.card.promisedHint": "O quanto antes: prometemos {time} ao cliente.",
    "pedidos.pos.printer.none": "Impressora: nenhuma conectada. Os pedidos aparecem na tela, mas não sai o papel para a cozinha.",
    "pedidos.pos.printer.ok": "Há uma impressora conectada para os pedidos.",

    "pedidos.pos.expired.title": "Expirados sem resposta ({n})",
    "pedidos.pos.expired.show": "Ver",
    "pedidos.pos.expired.hide": "Ocultar",
    "pedidos.pos.expired.wa": "Olá {name}, escrevemos pelo seu pedido {code}. Desculpe não responder a tempo: você ainda quer?",

    "pedidos.pos.banner.newOne": "Pedido online de {name} · {total}",
    "pedidos.pos.banner.newMany": "{n} pedidos online esperando resposta",
    "pedidos.pos.banner.see": "Ver",
    "pedidos.pos.banner.soundLocked": "O aviso de pedidos online está em silêncio nesta tela.",
    "pedidos.pos.banner.soundCta": "Toque para ativar o som",
    "pedidos.pos.banner.soundLockedOpen": "O aviso de pedidos online está em silêncio nesta tela. Se nenhuma tela tocar, em {min} min a loja fecha para os clientes.",
    "pedidos.pos.banner.offline": "Sem conexão: os pedidos online não podem ser aceitos. Se alguém está esperando, ligue.",
    "pedidos.pos.banner.noInternet": "O PC está sem internet: os pedidos online não chegam. Atenda pelo WhatsApp ou por telefone até voltar.",
    "pedidos.pos.banner.noInternetBoot": "O PC ligou sem internet: os pedidos online não chegam até ele se conectar. Atenda pelo WhatsApp ou por telefone.",
    "pedidos.pos.banner.attention": "Pedidos expiraram sem ninguém ver. Você continua recebendo pedidos online?",
    "pedidos.pos.banner.attentionYes": "Sim, continuo",
    "pedidos.pos.banner.autoPaused": "A loja online fechou sozinha porque ninguém respondia os pedidos.",
    "pedidos.pos.banner.catalogIssue": "O cardápio tem um problema e a loja online não recebe pedidos. Revise no editor.",
    "pedidos.pos.banner.waitingOne": "O pedido de {name} ainda espera resposta · vence em {min} min",
    "pedidos.pos.banner.waitingMany": "{n} pedidos online ainda esperam resposta · o primeiro vence em {min} min",
    "pedidos.pos.nav.badge": "{n} pedidos online esperando",
    "pedidos.pos.list.web": "WEB",

    "pedidos.pos.paper.web": "WEB",
    "pedidos.pos.paper.client": "Cliente: {name}",
    "pedidos.pos.paper.webCode": "Pedido web {code}",
    "pedidos.pos.paper.verifyTransfer": "CONFERIR A TRANSFERENCIA ANTES DE ENTREGAR",
    "pedidos.pos.paper.transferReceived": "TRANSFERENCIA RECEBIDA",
    "pedidos.pos.paper.transferAmount": "TRANSFERENCIA {amount}",
    "pedidos.pos.paper.feeCoordinate": "Entrega: a combinar",
    "pedidos.pos.paper.ref": "Ref. (cliente): {ref}",
    "pedidos.pos.paper.promised": "PROMETIDO {time}",
    "pedidos.pos.paper.feeCoordinateHint": "(à parte: não está no total nem no troco)",
    "pedidos.pos.paper.testTag": "TESTE - NÃO PREPARAR",
    "pedidos.pos.paper.testTop": "PEDIDO DE TESTE - NÃO ENTREGAR",
    "pedidos.pos.paper.testBottom": "É um teste: não é cobrado nem entra no caixa",
    "pedidos.pos.paper.testLabel": "TESTE",
    "pedidos.pos.cashLabel": "Desconto dinheiro",

    "pedidos.pos.toast.printed": "{order}: aceito · enviando para a cozinha…",
    "pedidos.pos.toast.awaitingPay": "{order}: aceito. O cliente vê sua chave; a comanda sai quando você tocar «A transferência chegou».",
    "pedidos.pos.toast.paidPrinted": "{order}: a transferência chegou · enviando para a cozinha…",
    "pedidos.pos.toast.paidNoPrinter": "A transferência de {name} chegou, mas não há impressora: a comanda NÃO saiu. Verifique a impressora e toque «Montar e imprimir» no cartão.",
    "pedidos.pos.toast.built": "{order}: aceito. Revise e envie para a cozinha.",
    "pedidos.pos.toast.mismatch": "{order}: o total não bate ({got} aqui, {expected} para o cliente). Não foi impresso: revise antes de enviar.",
    "pedidos.pos.toast.lost": "Outro aparelho já aceitou o pedido de {name}.",
    "pedidos.pos.toast.builtElsewhere": "{order}: outro aparelho já montou este pedido.",
    "pedidos.pos.toast.leaseHeld": "Outro aparelho está montando este pedido. Tente em alguns segundos.",
    "pedidos.pos.toast.expired": "O pedido de {name} expirou antes de ser aceito: o cliente pode já estar pedindo pelo WhatsApp.",
    "pedidos.pos.toast.gone": "Esse pedido não está mais esperando (o cliente cancelou ou outro aparelho respondeu).",
    "pedidos.pos.toast.testPrinted": "Teste aceito: confira a comanda e o ticket da sacola. Nada entrou no caixa.",
    "pedidos.pos.toast.testNoPrinter": "O teste foi aceito, mas nenhuma impressora de comandas está conectada: não saiu nenhum papel.",
    "pedidos.pos.toast.testDiscarded": "Teste descartado.",
    "pedidos.pos.toast.offline": "Sem conexão: não foi possível aceitar o pedido de {name}. Ligue para {phone}.",
    "pedidos.pos.toast.buildError": "Não foi possível montar o pedido de {name} ({code}). Atenda pelo WhatsApp ou cancele pelo cartão; se repetir, recarregue a página.",
    "pedidos.pos.toast.orderClosed": "A comanda desse pedido já está paga ou anulada.",
    "pedidos.pos.toast.error": "Não foi possível ({code}). Tente de novo.",
    "pedidos.pos.toast.rejected": "Você recusou o pedido de {name}.",
    "pedidos.pos.toast.rejectedSoldOut": "Você recusou o pedido de {name} e marcou {n} esgotado(s) até fechar.",
    "pedidos.pos.toast.ready": "Avisamos {name} que está pronto.",
    "pedidos.pos.toast.out": "Avisamos {name} que está a caminho.",
    "pedidos.pos.toast.paid": "Transferência de {name} marcada como recebida.",
    "pedidos.pos.toast.done": "Pedido de {name} entregue.",
    "pedidos.pos.toast.canceled": "Você cancelou o pedido de {name}.",
    "pedidos.pos.toast.amended": "{name} já vê o total novo.",
    "pedidos.pos.toast.actionOffline": "Sem conexão com a nuvem: não deu para avisar. Tente de novo daqui a pouco.",
    "pedidos.pos.toast.orderLinked": "Esse pedido já tem comanda: cobre ou anule pelo pedido.",
    "pedidos.pos.toast.aboveCeiling": "É mais do que o cliente confirmou ({max}): toque em «O cliente aceitou» só se você falou com ele.",
    "pedidos.pos.toast.storeOpen": "Loja online aberta: já podem pedir.",
    "pedidos.pos.toast.storeOpenWa": "Loja aberta, mas os pedidos do seu link chegam pelo WhatsApp (não nesta caixa). Para recebê-los aqui, escolha «Receber em Comandas» nas configurações de pedidos online.",
    "pedidos.pos.toast.storeClosed": "Loja online fechada.",
    "pedidos.pos.toast.storePaused": "Loja online em pausa.",
    "pedidos.pos.toast.soldOutSaved": "Marcado como esgotado.",
    "pedidos.pos.toast.noPrinter": "{order}: aceito, mas NÃO saiu para a cozinha: não há impressora disponível. Confira a impressora e toque em «Enviar» no pedido.",
    // Los avisos de "la comanda no salió" de un pedido que NO es de mesa (envío, retiro, apps): sin el
    // "MESA" adelante. {table} = "Envío #4 · Juana Pérez" (orderNoticeName). Ver TEXTO_SIN_MESA.
    "pedidos.pos.print.failedTable": "{table}: a comanda NÃO saiu. Esses itens voltaram para pendentes: confira a impressora e toque em Enviar de novo.",
    "pedidos.pos.print.failedMixed": "{table}: parte da comanda não saiu e voltou para pendentes, e outra parte não pôde ser confirmada. Confira as impressoras antes de reimprimir.",
    "pedidos.pos.print.failedReprint": "{table}: a comanda NÃO saiu. Confira a impressora e reimprima a comanda completa.",
    "pedidos.pos.print.failedTableClosed": "{table}: a comanda NÃO saiu e o pedido já foi fechado. Verifique se ainda falta fazer esse pedido.",
    "pedidos.pos.print.unconfirmedTable": "{table}: não conseguimos confirmar a impressão. Confira a impressora ANTES de reimprimir: pode ter saído mesmo assim.",
    "pedidos.pos.print.chargedDone": "{table}: fechado ✓",
    "pedidos.pos.print.voidDone": "{table}: anulado",
    "pedidos.pos.toast.cannotBuild": "O pedido de {name} não pode ser montado nesta tela ({code}). Não aceite: recuse ou atenda pelo WhatsApp. Se repetir, recarregue a página.",
    "pedidos.pos.toast.notReady": "Os pedidos de hoje ainda estão carregando. Tente de novo em um segundo.",
    "pedidos.pos.toast.acceptUnknown": "A conexão caiu e não sabemos se o pedido de {name} foi aceito. NÃO lance à mão: quando a conexão voltar, o cartão mostra como ficou.",
    "pedidos.pos.toast.acceptedNotBuilt": "O pedido de {name} ficou ACEITO mas ainda não saiu para a cozinha (a conexão caiu). Quando voltar, toque em «Montar e imprimir» ou «Mandar para a cozinha» no cartão. Não lance à mão.",
    "pedidos.pos.toast.rejectOffline": "Sem conexão: não foi possível recusar o pedido de {name}. Se a conexão não voltar, avise pelo {phone}.",
    "pedidos.pos.toast.rejectUnknown": "A conexão caiu e não sabemos se o pedido de {name} foi recusado. Quando voltar, o cartão mostra como ficou.",
    "pedidos.pos.toast.saveError": "O pedido de {name} foi aceito, mas não foi possível salvar a comanda ({code}). Toque em «Montar e imprimir» no cartão para tentar de novo. Não lance à mão.",
    "pedidos.pos.toast.actionUnknown": "A conexão caiu e não sabemos se foi feito. Confira o pedido e, se precisar, tente de novo.",
    "pedidos.pos.toast.tellKitchen": "Avise a cozinha: {table} foi cancelado (não há impressora para imprimir o cancelamento).",
    "pedidos.pos.toast.resend": "Reenviar à cozinha",

    "pedidos.pos.gate.off": "Os pedidos online ainda não estão habilitados para o seu local.",
    "pedidos.pos.gate.noPack": "A loja online precisa do pacote Gestão ativo.",
    "pedidos.pos.gate.disabled": "A loja online está desligada na configuração.",
    "pedidos.pos.gate.notConfigured": "Falta completar a configuração (WhatsApp, formas de pagamento ou tipo de pedido).",
    "pedidos.pos.gate.noHours": "Falta confirmar o horário na configuração da loja online.",
    "pedidos.pos.gate.outOfHours": "Você abriu a loja, mas está fora do horário: vai receber pedidos quando abrir.",
    "pedidos.pos.gate.paused": "A loja está em pausa.",
    "pedidos.pos.gate.noPresence": "Aberta, mas nenhuma tela com som está atenta: ative o som aqui.",
    "pedidos.pos.gate.catalog": "O cardápio tem um problema: os clientes não podem pedir até você corrigir.",
    "pedidos.pos.gate.closed": "A loja continua fechada.",
    "pedidos.pos.gate.unknown": "A loja não está recebendo pedidos. Revise a configuração.",
  },
};

export default pos;
